import Backbone from 'backbone'
import template from './delete-confirmation-tooltip.hbs'
import i18n from 'scoreboard/components/i18n'

var DeleteConfirmationTooltip = Backbone.View.extend({

	events: {
		'click .cancel': 'cancel',
		'click .delete': 'delete'
	},

	/**
	 *
	 * @param {String} options.label This should be a label of the thing that is
	 * being deleted (e.g. 'Bookmark', 'Alert', etc)
	 *
	 * @param {String} [options.message=Are you sure you want to delete this {0}]
	 * Optionally provide the entire message for the prompt
	 *
	 */
	initialize: function(options) {
		this.options = options || {}
	},

	render: function() {
		this.$el.empty().append(template({
			message: this.options.message ||
				i18n.get('common.delete.confirmation', this.options.label)
		}))
		return this
	},

	cancel: function() {
		this.trigger('cancel')
	},

	'delete': function() {
		this.trigger('delete')
	}

})

export default DeleteConfirmationTooltip

DeleteConfirmationTooltip.__filename__ = 'components/delete-confirmation-tooltip.js'
